module.exports = __webpack_public_path__ + "static/media/sequipament_white.f453c986.svg";